var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTennisBall = function SvgTennisBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.781 4.987A16.25 16.25 0 1 1 26.22 35.012 16.25 16.25 0 0 1 13.78 4.987ZM20 6.25a13.75 13.75 0 0 0-8.134 2.664 16.25 16.25 0 0 1 0 22.172 13.745 13.745 0 0 0 13.396 1.617 13.745 13.745 0 0 0 2.872-1.617 16.25 16.25 0 0 1 0-22.172A13.752 13.752 0 0 0 20 6.25Zm10.008 4.32a13.75 13.75 0 0 0 0 18.859 13.75 13.75 0 0 0 0-18.858ZM7.297 14.739a13.75 13.75 0 0 1 2.696-4.167 13.752 13.752 0 0 1 0 18.858 13.75 13.75 0 0 1-2.696-14.69Z",
    clipRule: "evenodd"
  })));
};
export default SvgTennisBall;